export default function () {
  return {
    usuario: {},
    colaborador: {},
    loggedIn: false
  }
}
